// extracted by mini-css-extract-plugin
export default {"melodyVideo":"dJ-z","isFullWidth":"eJ-z","landingPageVideo":"fJ-z","play":"gJ-z","iframeVideo":"hJ-z","playHidden":"iJ-z","fullwidth":"jJ-z"};